module.exports = __webpack_public_path__ + "static/media/img-poster_activo.2314a331.svg";